import React, { useEffect, useState } from "react";
import API from "../api";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../styles/gallery.css";

export default function Gallery() {
  const [data, setData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const IMAGE_URL = process.env.REACT_APP_UPLOAD_URL;

  const load = async () => {
    try {
      const res = await API.get("/gallery");

      console.log("Gallery Data:", res.data);
      console.log("IMAGE_URL:", IMAGE_URL);

      setData(res.data.data || []);
    } catch (err) {
      console.error("Error load gallery:", err);
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, [selectedIndex, data]);

  useEffect(() => {
    document.body.style.overflow =
      selectedIndex !== null ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedIndex]);

  const openImage = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const nextImage = () => {
    setSelectedIndex((prev) =>
      prev === data.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? data.length - 1 : prev - 1
    );
  };

  const getImageUrl = (file) => {
    if (!file) return "/default-image.jpg";

    return `${IMAGE_URL}/uploads/${file}`;
  };

  return (
    <div className="ig-gallery-container">
      <h2 className="ig-title">📸 Galeri</h2>

      {data.length === 0 ? (
        <div className="text-center mt-4">
          <p>Belum ada gallery.</p>
        </div>
      ) : (
        <div className="ig-grid">
          {data.map((g, index) => (
            <div
              key={g.id}
              className="ig-item"
              onClick={() => openImage(index)}
            >
              <img
                src={getImageUrl(g.image)}
                alt={g.title || "gallery"}
                onError={(e) => {
                  e.target.src = "/default-image.jpg";
                }}
              />

              <div className="ig-overlay">
                <span>{g.title}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* LIGHTBOX MODAL */}
      {selectedIndex !== null &&
        data[selectedIndex] && (
          <div
            className="ig-modal"
            onClick={closeModal}
          >
            <button
              className="close-btn"
              onClick={closeModal}
            >
              <FaTimes />
            </button>

            <button
              className="nav-btn left"
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
            >
              <FaChevronLeft />
            </button>

            <img
              className="modal-img"
              src={getImageUrl(
                data[selectedIndex].image
              )}
              alt={
                data[selectedIndex].title ||
                "preview"
              }
              onClick={(e) => e.stopPropagation()}
              onError={(e) => {
                e.target.src = "/default-image.jpg";
              }}
            />

            <button
              className="nav-btn right"
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
            >
              <FaChevronRight />
            </button>
          </div>
        )}
    </div>
  );
}